<template>
  <el-row type="flex" justify="center" align="middle" style="height: 40px">
    <span
      class="tg-btn tg-btn--status"
      :class="{ 'is-true': status == 1, 'is-lock': disabled }"
      @click="!disabled ? $emit('on-click') : $emit('on-click-disabled')"
    >
      <font-awesome-icon :icon="statusIcon" size="1x"></font-awesome-icon>
    </span>
  </el-row>
</template>

<script>
export default {
  props: {
    status: [Number, String],
    disabled: Boolean,
    data: Object,
  },
  computed: {
    statusIcon() {
      return this.status == 0 ? "times" : ["far", "circle"];
    },
  },
};
</script>
